import { useMutation, useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import { SrxApi } from '../api/SrxApi';

const useEditReleaseNote = (setIsVersionModalOpen) => {
  const queryClient = useQueryClient();

  const { mutate: editReleaseNote, isLoading } = useMutation(
    async ({ payload }) => {
      if (!payload.Id) {
        throw new Error('Release note ID is required for editing');
      }
      const response = await SrxApi.post(`/versions/release-notes/create-or-edit`, payload);
      return response?.data;
    },
    {
      onSuccess: (data) => {
        if (data) {
          setIsVersionModalOpen(false);
          toast.success(data?.message || "Release note updated successfully!");
          queryClient.invalidateQueries(["currentVersion"]);
          queryClient.invalidateQueries(["getAllReleaseNote"]);
        }
      },
      onError: (error) => {
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to update release note";
        toast.error(errorMessage);
      },
    }
  );

  return { editReleaseNote, isEditReleaseNoteLoading: isLoading };
};

export default useEditReleaseNote;